
import Vue from 'vue'

export default Vue.extend({
  name: 'MobileMenuLinks',

  data () {
    return {
      group: null,
      whatsappUrl: 'https://api.whatsapp.com/send/?phone=447988898671&text=Hi%20there%21%20I%E2%80%99d%20like%20to%20find%20out%20more%20about%20the%20solutions%20provided%20by%20ARI.company.%20When%20would%20be%20a%20good%20time%20to%20connect%20and%20discuss%20how%20your%20services%20can%20benefit%20me%3F&type=phone_number&app_absent=0'
    }
  }
})
